<script lang="ts">
    import { onMount } from 'svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    import { faUser } from '@fortawesome/free-solid-svg-icons'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    dayjs.locale('pt-br')

    let show = false

    let grid: GridClass = null
    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: any[] = await window.api.pos.reports.InvoicesPersonsPending(new Date(0, 0, 0), new Date(2099, 1, 1))
        grid = new GridClass()
        grid.title = 'Pessoas com crédito (financeiro)'
        //grid.subtitle = 'Selecione o período onde deve'
        grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
        grid.cols.push(new GridCol({ content: 'Nascimento', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Crédito', type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
        data = await window.api.utils.utils.assignPersonsFromObject(data)
        for (const item of data) {
            let credit = item.totalPaid - item.total
            if (credit < 0.1) continue
            if (credit > 0) {
                let btnPerson: GridButton = new GridButton({
                    callback: () => window.person('show', item.person.personId),
                    icon: faUser,
                })
                let line: GridLine = new GridLine()
                line.slots.push({ content: item.person?.createdAt })
                line.slots.push({ content: item.person?.name })
                line.slots.push({ content: item.person?.phone })
                line.slots.push({ content: item.person?.email })
                line.slots.push({ content: item.person?.born })
                line.slots.push({ content: credit })
                line.slots.push({ content: [btnPerson] })
                grid.lines.push(line)
            }
        }
        console.log('grid', grid)
        grid = grid
        show = false
    }

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
